import { Location } from '@angular/common';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { CompatModule } from './compat/compat.module';
import { environment } from './environments/environment';

// FIXME: remove that when URL consistency has been fixed in GAF
(Location as any).stripTrailingSlash = function _stripTrailingSlash(
  url: string,
): string {
  return url;
};

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(CompatModule, {
  preserveWhitespaces: false,
});
